import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NotificationLevel, NotificationService } from '@core/notifications/notification.service';
import { AurButtonComponent } from '@shared/ui/aur/aur-button/aur-button.component';

const LEVEL_TOAST: Record<NotificationLevel, string> = {
  success: 'toast toast--success toast--soft',
  info: 'toast toast--brand toast--soft',
  warning: 'toast toast--warning toast--soft',
  error: 'toast toast--danger toast--soft',
};

/**
 * Global toast host using AUR toast styles (no Bootstrap).
 * Callers: App shell. Affected API: NotificationService dismiss/items only.
 * User: remove bootstrap… retain AUR styles… list creds and routes.
 */
@Component({
  selector: 'app-toast-host',
  imports: [AurButtonComponent],
  template: `
    <div class="toast-stack" aria-live="polite" aria-atomic="true">
      @for (item of notifications.items(); track item.id) {
        <div [class]="levelClass[item.level]" role="status">
          <div class="toast__text">
            <p class="toast__description">{{ item.message }}</p>
          </div>
          <aur-button
            intent="neutral"
            variant="ghost"
            [size]="24"
            [iconOnly]="true"
            leftIcon="x-outline"
            ariaLabel="Close"
            (clicked)="notifications.dismiss(item.id)"
          />
        </div>
      }
    </div>
  `,
  styles: `
    :host {
      position: fixed;
      top: var(--space-16, 16px);
      right: var(--space-16, 16px);
      z-index: 60;
      display: block;
      pointer-events: none;
    }

    .toast-stack {
      display: flex;
      flex-direction: column;
      gap: var(--gap-8, 8px);
      pointer-events: auto;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastHostComponent {
  protected readonly notifications = inject(NotificationService);
  protected readonly levelClass = LEVEL_TOAST;
}
